/* generated using openapi-typescript-codegen -- do no edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

export type TenantWrite = {
    entity_id?: string
    login_url?: string
    logout_url?: string
    cert?: string
    metadata?: string
    name_id_format?: TenantWrite.name_id_format
}

export namespace TenantWrite {
    export enum name_id_format {
        PERSISTENT = 'persistent',
        TRANSIENT = 'transient',
        EMAIL_ADDRESS = 'emailAddress',
        UNSPECIFIED = 'unspecified',
        X509SUBJECT_NAME = 'X509SubjectName',
        WINDOWS_DOMAIN_QUALIFIED_NAME = 'WindowsDomainQualifiedName',
        KERBEROS = 'kerberos',
        ENTITY = 'entity'
    }
}
